import React from 'react';
import PropTypes from 'prop-types';
import RToggle from 'react-toggle';

import 'react-toggle/style.css';

import styles from './styles.scss';

const Toggle = ({ checked, onChange }) => {
  const className = checked ? styles.toggleActive : styles.toggleInactive;

  return <RToggle checked={checked} onChange={onChange} icons={false} className={className} />;
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

export default Toggle;



// WEBPACK FOOTER //
// src/components/shared/Toggle/index.jsx